module.exports = __webpack_public_path__ + "static/media/tl_security.b06e7448.svg";